const { validate: idValidate, test: idTest } = require('./id-percentage')

module.exports = {
  validate(rule) {
    rule.idType = 'shopperId';
    return idValidate(rule);
  },

  test({ key, rule, params}) {
    rule.idType = 'shopperId';
    return idTest({ key, rule, params})
  }
};
